import { styled } from "@mui/material/styles";
import { ContainedButton } from "../../../../../components/Buttons/ContainedButton";

export const Button = styled(ContainedButton)(({ theme }) => ({
  padding: "5px 30px !important",
  minHeight: "auto !important",
  height: "34px !important",
  fontWeight: 600,
  borderRadius: "100px",
  fontSize: "14px",
  "& span": {
    fontSize: "14px"
  },
  [theme.breakpoints.up("sm")]: {
    fontSize: "14px !important",
    padding: "12px 45px",
    "& span": {
      fontSize: "14px !important"
    }
  }
}));

export const WithdrawButton = styled(Button)(({ theme }) => ({
  backgroundColor: "white !important",
  "> .labelStyle": {
    color: "#000 !important"
  }
}));

export const SubTitle = styled("div")(({ theme }) => ({
  paddingTop: theme.spacing(2.5),
  fontSize: "16px",
  "& > div": {
    width: "4px"
  }
}));

export const PadT7 = styled("div")({
  paddingTop: "7px !important"
});

export const NoPadding = styled("div")({
  padding: 0
});

export const MainContainer = {
  width: "500px",
  gap: "24px",
  paddingTop: "7px"
};
